export default __webpack_public_path__ + "static/cutting-d591de9c5e982e4d208249a8153289f0.mp3";